<template>
    <div class="row pt-3" style="border-top: 1px dashed rgba(106, 113, 133, 0.3);">
        <div class="col-sm-12">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">Select Trigger:</h6>
                </label>
                <select class="form-select" v-model="compState.triggerType">
                    <option v-for="trigger in triggerList" :value="trigger.id">{{ trigger.name }}</option>
                </select>
                <textarea class="form-control mt-3" placeholder="Description" style="resize: none; height: 10rem;"
                    readonly :value="selectedTriggerDescription"></textarea>
            </div>
        </div>
        <div class="col-12">
            <IndividualDepartment v-if="compState.triggerType === '1'" />
            <MultiDepartment v-else-if="compState.triggerType === '2'" />
            <IndividualGroup v-else-if="compState.triggerType === '4'" />
            <MultiProductGroup v-else-if="compState.triggerType === '5'" />
            <IndividualPLU v-else-if="compState.triggerType === '6'" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, reactive, watch, onMounted, defineAsyncComponent } from 'vue'
import { usePromotionStore, triggerList } from '@/store/management/promotionStore';
import type { Promotion } from '@/store/management/promotionStore';

const IndividualDepartment = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionTrigger/IndividualDepartment.vue'))
const MultiDepartment = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionTrigger/MultiDepartment.vue'))
const IndividualGroup = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionTrigger/IndividualGroup.vue'))
const MultiProductGroup = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionTrigger/MultiProductGroup.vue'))
const IndividualPLU = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionTrigger/IndividualPLU.vue'))

const promotionStore = usePromotionStore()

const compState = reactive({
    triggerType: '',
})

const activePromotion = computed(() => {
    return promotionStore.getActivePromotion
})

const tempActivePromotion = computed(() => {
    return promotionStore.getActivePromotion
})

const activePromotionId = computed(() => {
    return promotionStore.getActivePromotion.basic.id
})

const selectedTriggerDescription = computed(() => {
    return triggerList.find(trigger => trigger.id === compState.triggerType)?.description
})

onMounted(() => {
    if (tempActivePromotion.value?.basic.id) {
        compState.triggerType = tempActivePromotion.value.trigger.selectedTrigger
    }
})

watch(activePromotionId, (newVal) => {
    if (newVal) {
        const promotion = activePromotion.value
        compState.triggerType = promotion.trigger.selectedTrigger
    }
}, { immediate: true });

watch(compState, (newVal) => {
    promotionStore.setActivePromotion({
        ...tempActivePromotion.value,
        trigger: {
            ...tempActivePromotion.value.trigger,
            selectedTrigger: newVal.triggerType
        }
    } as Promotion)
}, { deep: true });

</script>

<style scoped lang="scss">
.destination-container {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 1rem;
}

.hover-pointer {
    cursor: pointer;
}

.nav-link {
    color: var(--bs-heading-color);
}
</style>